import type { Configuration } from '@carvana/microfrontend';
import { MfeReact } from '@carvana/microfrontend-react';

const mfeConfig: Configuration = {
  name: 'stripe-ui',
  Render: MfeReact,
  ENV: process.env.NODE_ENV as 'development' | 'test' | 'prod',
  debug: false,
  globals: {
    React: () => import('react'),
    ReactDOM: () => import('react-dom'),
    'react-dom': () => import('react-dom'),
    styled: () => import('styled-components'),
    'styled-components': () => import('styled-components'),
    'prop-types': () => import('prop-types'),
    PropTypes: () => import('prop-types'),
  },
  files: [
    [
      'HeaderModule',
      [
        {
          component: 'default',
          default: {
            file: `index.js`,
            manifest: `${process.env.ASSETS_CDN_URL}/header/module/assets-manifest.json`,
          },
        },
      ],
    ],
    [
      'FooterModule',
      [
        {
          component: 'default',
          legacy: true,
          default: {
            file: `index.js`,
            manifest: `${process.env.ASSETS_CDN_URL}/footer/module/assets-manifest.json`,
          },
        },
      ],
    ],
  ],
};

export default mfeConfig;
